export const filterSearchWeb = (state: any) => {
  const copyData = state.searchData;
  const filterData = copyData.filter((list: any) => {
    if (list.title?.toLowerCase().includes(state.searchName)) {
      return list;
    }
  });
  state.apiData = filterData;
};
